import styled from 'styled-components';

import { Box, CircularProgress, Tabs } from '@mui/material';

export const Loading = styled(CircularProgress)`
  justify-content: center;
`;

export const ContainerLoadingTabela = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const TabContainer = styled(Box)`
  margin-top: 20px;
  width: 100%;
`;

export const StyledTabs = styled(Tabs)({
  borderBottom: '1px solid #fff',
  padding: 0,
  '& .MuiTab-root': {
    width: 'auto',
    minWidth: 'unset',
    maxWidth: '100%',
    padding: '0px 12px',
    color: '#263C6A',
    textTransform: 'none',
    fontWeight: 'normal',
    fontSize: '14px',
    backgroundColor: '#ececec',

    borderRight: '2px solid #fff',
    borderBottom: '2px solid #fff',
    whiteSpace: 'nowrap',
    '&.Mui-selected': {
      fontWeight: 'bold',
      fontSize: '14.5px',
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#fff',
  },
  '& .MuiTabs-scrollButtons': {
    backgroundColor: '#263C6A',
    opacity: '1',
    color: '#FFFFFF',
  },
  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: '0.3',
  },
});
